import * as THREE from 'three';
export const DEFAULT_SPOKE_PANEL_LABEL_OFFSET = [0, 0, 0.02];
export const SPOKE_PANEL_LABEL_ROTATION = [0, 0, 0];
export function normalizeSpokePanelLabelOffset(offset) {
    if (!offset)
        return DEFAULT_SPOKE_PANEL_LABEL_OFFSET;
    return [offset[0] ?? 0, offset[1] ?? 0, offset[2] ?? 0];
}
export function computeSpokePanelTextSpinToFaceOrigin(args) {
    const { originNearestPosition, direction, itemOffset, spokeRotation } = args;
    const spokeRotationQuaternion = new THREE.Quaternion().setFromEuler(new THREE.Euler(...(spokeRotation ?? [0, 0, 0]), 'XYZ'));
    const baseQuat = spokeRotationQuaternion.clone().multiply(new THREE.Quaternion().setFromEuler(new THREE.Euler(...SPOKE_PANEL_LABEL_ROTATION, 'XYZ')));
    const itemWorldPosition = new THREE.Vector3(...originNearestPosition).add(new THREE.Vector3(...direction)
        .multiplyScalar(itemOffset)
        .applyQuaternion(spokeRotationQuaternion));
    const toOriginWorld = itemWorldPosition.multiplyScalar(-1);
    if (toOriginWorld.lengthSq() < 1e-12)
        return 0;
    const toOriginLocal = toOriginWorld.clone().applyQuaternion(baseQuat.clone().invert());
    const tx = toOriginLocal.x;
    const ty = toOriginLocal.y;
    if (tx * tx + ty * ty < 1e-12)
        return 0;
    const rawSpin = Math.atan2(tx, ty);
    const textUpWorld = new THREE.Vector3(0, 1, 0)
        .applyAxisAngle(new THREE.Vector3(0, 0, 1), rawSpin)
        .applyQuaternion(baseQuat)
        .normalize();
    return textUpWorld.dot(toOriginWorld.clone().normalize()) >= 0 ? rawSpin + Math.PI : rawSpin;
}
